import { take, put } from "redux-saga/effects";
import { ADD_CONTENT_TO_ASSIGNMENT, addContentToAssignmentActions } from "src/redux/actions/assignments";

// services
import { addContentToAssignment } from "src/services/http/assignments";

// types
import { AddContentToAssignmentRequestTypes } from "src/redux/actions/assignments/types";

import * as Effects from "redux-saga/effects";

const call: any = Effects.call;

function* watchAddContentToAssignmentRequest() {
  while (true) {
    const { payload }: IActionType<AddContentToAssignmentRequestTypes> = yield take(ADD_CONTENT_TO_ASSIGNMENT.REQUEST);

    const { onSuccess, ...apiPayload } = payload;

    try {
      yield call(addContentToAssignment, apiPayload as AddContentToAssignmentRequestTypes);

      yield put(addContentToAssignmentActions.success(apiPayload as AddContentToAssignmentRequestTypes));

      if (onSuccess) {
        onSuccess();
      }
    } catch (e) {
      console.log(e, "error");
      yield put(addContentToAssignmentActions.error(e as any));

      if (onSuccess) {
        onSuccess();
      }
    }
  }
}

export default watchAddContentToAssignmentRequest;
